import { render, staticRenderFns } from "./basePaymentTerm.vue?vue&type=template&id=707332cc&"
import script from "./basePaymentTerm.vue?vue&type=script&lang=js&"
export * from "./basePaymentTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('707332cc')) {
      api.createRecord('707332cc', component.options)
    } else {
      api.reload('707332cc', component.options)
    }
    module.hot.accept("./basePaymentTerm.vue?vue&type=template&id=707332cc&", function () {
      api.rerender('707332cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/basePaymentTerm.vue"
export default component.exports